import "./index.css";
function BlogHeader() {

    return (
        <div className="blogHeader">
            <div className="rowFirst">
                <div className="columnFirst">
                    
                </div>
                <div className="columnSecond">
                    <h1>My MAGAZINE</h1>
                </div>
                <div className="columnThird">
                    
                </div>
            </div>
            <div className="rowSecond">
                <div>
                    <div><h4>Home</h4></div>
                    <div><h4>Most popular</h4></div>
                    <div><h4>Last posts</h4></div>
                </div>
            </div>
        </div>
    );
}

export default BlogHeader;
